import { SAMARITAN_URL } from '../settings';

export async function fetchOrganization(orgId: number) {
    let base_url = `${SAMARITAN_URL}/api/v3/organizations/${orgId}`;
    let url = `${base_url}`;

    return fetch(url).catch((error) => {
        console.log('Fetching organization error:', error);
        throw error;
    });
}

export async function fetchAllOrganizations() {
    let base_url = `${SAMARITAN_URL}/api/v3/organizations`;

    return fetch(base_url).catch((error) => {
        console.log('Fetching all organizations error:', error);
        throw error;
    });
}
